import { type Module } from "vuex";
import type { AxiosError } from "axios";
import type { DefaultApi } from "@/api";
import { KomboJobState } from "@/models/kombo_job_state";
import { KomboJobStates } from "@/models/kombo_job_states";
import type { State as RootState } from "@/stores";
export interface State {
  jobStates?: KomboJobStates;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    jobStates: undefined,
  },
  actions: {
    async getJobStates({ commit }) {
      try {
        const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
          root: true,
        });
        const response = await api.getJobStates();
        const jobStates = new KomboJobStates(
          response.data.map((jobState) => new KomboJobState(jobState)),
        );
        commit("setJobStates", jobStates);
        return jobStates;
      } catch (error) {
        if ((error as AxiosError).response?.status === 404) {
          return null;
        }
        throw error;
      }
    },
  },
  mutations: {
    setJobStates(state, jobStates: KomboJobStates) {
      state.jobStates = jobStates;
    },
  },
};
